/* acaciasupplies — product-object.js (store-v9-1 S6). La ficha: galería,
   variantes, compra y barra. Sin dependencias, ≤ 8 KB. Nada se anima aquí:
   «Added» y el panel son de motion.js + cart-drawer.js (docs/motion.md). */
(function (d, w) {
  'use strict';
  var page = d.querySelector('[data-object-page]');
  if (!page) return;
  var $ = function (s, r) { return (r || page).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || page).querySelectorAll(s)); };

  /* ── Galería: miniaturas/puntos sin desplazamiento animado, zoom ── */
  var track = $('[data-gallery-track]');
  if (track) {
    var slides = $$('[data-gallery-slide]', track);
    var gos = $$('[data-gallery-go]');
    var current = 0;
    var mark = function (i) {
      current = i;
      gos.forEach(function (b) {
        if (+b.getAttribute('data-gallery-go') === i) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    };
    gos.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-gallery-go');
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'instant' });
        mark(i);
      });
    });
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) mark(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    var dialog = $('[data-gallery-dialog]');
    var stage = $('[data-gallery-stage]');
    var zoomBtn = $('[data-gallery-zoom]');
    var zoom = function (slide) {
      if (!dialog || !dialog.showModal || !slide) return;
      var img = d.createElement('img');
      img.src = slide.getAttribute('data-zoom-src');
      img.alt = slide.getAttribute('data-zoom-alt') || '';
      img.className = 'obj-zoom__img';
      stage.replaceChildren(img);
      dialog.showModal();
    };
    if (dialog && dialog.showModal) {
      if (zoomBtn) {
        zoomBtn.hidden = false;
        zoomBtn.addEventListener('click', function () { zoom(slides[current]); });
      }
      /* El toque en la Fig. 01 con interior es del efecto 7 (motion.js). */
      track.addEventListener('click', function (e) {
        var slide = e.target.closest('[data-gallery-slide]');
        if (!slide) return;
        if (e.pointerType === 'touch' && e.target.closest('[data-motion~="inside"]')) return;
        zoom(slide);
      });
      dialog.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { stage.replaceChildren(); });
    }
  }

  /* ── Variantes ── */
  var form = $('#obj-buy-form');
  var json = $('[data-variants-json]');
  var variants = [];
  try { variants = json ? JSON.parse(json.textContent) : []; } catch (err) { console.error('product-object: variants JSON', err); }
  var idInput = $('[data-variant-id]');
  var buy = $('[data-cta-buy]');
  var pay = $('[data-cta-pay]');
  var note = $('[data-cta-note]');
  var back = $('[data-notify-back]');
  var avail = $('[data-avail]');
  var price = $('.obj-page__price');
  var barPrice = d.querySelector('[data-bar-price]');
  var euros = function (c) {
    var r = c % 100;
    return ((c - r) / 100) + (r ? '.' + ('0' + r).slice(-2) : '') + ' €';
  };
  var chosen = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];
  var pick = function () {
    var opts = $$('[data-option]').map(function (g) {
      var c = g.querySelector('input:checked');
      return c ? c.value : null;
    });
    var v = variants.filter(function (x) {
      return x.o.every(function (o, i) { return opts[i] == null || String(o) === opts[i]; });
    })[0];
    if (!v) return;
    chosen = v;
    if (idInput) idInput.value = v.id;
    [buy, pay, note].forEach(function (el) { if (el) el.hidden = !v.a; });
    if (back) {
      back.hidden = v.a;
      var tags = back.querySelector('[data-notify-tags]');
      if (tags) tags.value = tags.value.replace(/back:\d*/, 'back:' + v.id);
    }
    if (avail) { avail.textContent = v.l; avail.hidden = !v.l; }
    if (v.p > 0) {
      if (price) price.textContent = euros(v.p) + ' · VAT included';
      if (barPrice) barPrice.textContent = euros(v.p);
    }
    try { history.replaceState(null, '', '?variant=' + v.id); } catch (err) { console.error('product-object: replaceState', err); }
  };
  $$('[data-option-input]').forEach(function (r) { r.addEventListener('change', pick); });

  /* ── Comprar: /cart/add.js por add() del carrito; sin él, el envío normal ── */
  var live = $('[data-cta-live]');
  if (form && buy) {
    form.addEventListener('submit', function (e) {
      var cart = w.acaciasupplies && w.acaciasupplies.cartDrawer;
      if (!cart || !idInput) return;
      e.preventDefault();
      var img = $('[data-gallery-slide] img');
      cart.add(idInput.value, 1, buy, {
        id: '', name: $('.obj-page__title').textContent.trim(),
        maker: ($('.obj-page__maker') || {}).textContent || '',
        variant: chosen && chosen.o.join(' / ') !== 'Default Title' ? chosen.o.join(' / ') : '',
        image: img ? img.currentSrc || img.src : '',
        price: chosen && chosen.p > 0 ? euros(chosen.p) : '',
        preorder: form.closest('[data-cta-kind]').getAttribute('data-ship-line') || ''
      }).then(function () {
        if (live) live.textContent = 'Added to your bag.';
      }, function () {
        if (live) live.textContent = 'We couldn’t add it. Please try again.';
      });
    });
  }

  /* ── La barra: cuando el bloque de compra sale de pantalla ── */
  var cta = $('[data-object-cta]');
  var bar = d.querySelector('[data-object-bar]');
  if (!cta || !bar) return;
  /* Fuera del <article>: un antepasado con `transform` (motion.css) haría
     de bloque contenedor del `position: fixed`. */
  d.body.appendChild(bar);
  var barBtn = bar.querySelector('[data-object-bar-cta]');
  if (barBtn) {
    barBtn.addEventListener('click', function () {
      if (bar.getAttribute('data-bar-kind') === 'buy' && form && buy && !buy.hidden) {
        if (form.requestSubmit) form.requestSubmit(buy); else buy.click();
        return;
      }
      var field = cta.querySelector('[data-capture]:not([hidden]) input[type="email"]');
      cta.scrollIntoView({ block: 'center' });
      if (field) field.focus({ preventScroll: true });
    });
  }
  if (!('IntersectionObserver' in w)) return;
  var mobile = w.matchMedia ? w.matchMedia('(max-width: 1023px)') : { matches: false };
  var title = $('.obj-page__title');
  var ctaIn = false, ctaAbove = false, titleGone = false;
  var sync = function () {
    bar.hidden = !(!ctaIn && (ctaAbove || (mobile.matches && titleGone)));
  };
  new IntersectionObserver(function (es) {
    var e = es[es.length - 1];
    ctaIn = e.isIntersecting;
    ctaAbove = !e.isIntersecting && e.boundingClientRect.top <= 0;
    sync();
  }).observe(cta);
  if (title) {
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      titleGone = !e.isIntersecting && e.boundingClientRect.top < 0;
      sync();
    }).observe(title);
  }
  if (mobile.addEventListener) mobile.addEventListener('change', sync);
})(document, window);
